<template>
    <section class="component" v-if="hasOverlay">
        <section class="component__header">
            <span class="component__header__title">
                {{$t('com.file.transmission-overlay-settings.title')}}
            </span>
        </section>
        <section class="component__body">
            <section class="d-flex flex-column gap-3 px-3">
                <section class="d-flex flex-row gap-2 align-items-center">
                    <input class="overlay-link" type="text" readonly :value="link" @focus="$event.target.select()" />
                    <ButtonOutline @click="copyLink" color="light">
                        {{$t('com.file.transmission-overlay-settings.copy')}}
                    </ButtonOutline>
                </section>
                <NoticeBox :title="$t('com.file.transmission-overlay-settings.vmix-version-title')"
                           :text="$t('com.file.transmission-overlay-settings.vmix-version-info')" />
                <p class="info">{{$t('com.file.transmission-overlay-settings.info')}}</p>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    import transmissionService from "@/services/transmission.service";
    import ButtonOutline from "../../../../BasicControls/Buttons/ButtonOutline.vue";
    import NoticeBox from "../../../../BasicControls/NoticeBox.vue";
    import { copyToClipboard } from "../../../../../helpers/utils";

    export default {
        name: "TransmissionOverlaySettings",
        components: {
            ButtonOutline,
            NoticeBox
        },
        data() {
            return {
                overlayCode: "",
                // box jest ukryty, dopoki serwer nie potwierdzi nakladki kodem - takze w trakcie ladowania
                hasOverlay: false
            }
        },
        computed: {
            /**
             * Sciezke daje router - trasa nakladki jest zdefiniowana w jednym miejscu, wiec
             * jej zmiana nie wymaga poprawki tutaj, a parametry i query sa poprawnie zakodowane.
             * Origin dokladamy z przegladarki, bo router zna tylko sciezke, a eSesja.Management.Api
             * za brama widzi wylacznie adres wewnetrzny (YARP nadpisuje naglowek Host).
             *
             * vMix nie ma jak wybrac jezyka, wiec doklejamy aktualnie ustawiony jezyk
             * interfejsu - nakladka rozwiazuje go potem przez setLocaleByLanguageCodeForOw.
             * Computed, zeby link nadazal za przelaczeniem jezyka w panelu.
             */
            link() {
                if (!this.overlayCode)
                    return "";

                const { href } = this.$router.resolve({
                    name: "Overlay",
                    params: { code: this.overlayCode },
                    query: { lang: this.$i18n.locale }
                });

                return `${window.location.origin}${href}`;
            }
        },
        async mounted() {
            await this.getOverlayLink();
        },
        methods: {
            async getOverlayLink() {
                try {
                    const response = await transmissionService.getOverlayLink();
                    const code = this.readOverlayCode(response.data);

                    if (response.status !== 200 || !code) {
                        this.hasOverlay = false;
                        return;
                    }

                    this.overlayCode = code;
                    this.hasOverlay = true;
                }
                catch {
                    // 404 = brak "Nakladki eSesja" albo transmisji dla kadencji - box zostaje ukryty
                    this.hasOverlay = false;
                }
            },
            /**
             * Usluga zwraca teraz sam kod. `link` jest obslugiwany przejsciowo, bo panel
             * i eSesja.Management.Api wdrazaja sie osobno - do czasu restartu uslugi
             * przychodzi jeszcze stary, wewnetrzny adres, z ktorego bierzemy koncowy kod.
             */
            readOverlayCode(data) {
                if (!data)
                    return "";

                if (data.code)
                    return data.code;

                if (!data.link)
                    return "";

                return data.link.split("?")[0].split("/").filter(Boolean).pop() || "";
            },
            async copyLink() {
                try {
                    await copyToClipboard(this.link);
                    this.$store.commit("showSuccessCustomMessage", this.$t('com.file.transmission-overlay-settings.link-copied'));
                }
                catch {
                    this.$store.commit("showError");
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @use "@/assets/scss/user-profile-component.scss";

    .component {
        width: 400px;
        height: fit-content;
    }

    .overlay-link {
        flex: 1;
        min-width: 0;
        padding: 8px 10px;
        border: 1px solid #dce4ee;
        border-radius: 4px;
        background: #f7f9fc;
        font-size: 13px;
        color: #00082c;
    }

    .info {
        font-size: 12px;
        color: #666c7a;
        margin: 0px;
    }
</style>
